
<div
  v-show="content.message || messageFromDOM"
  :id="content.idHTML"
  :class="[
    jel_getClassObject(content),
    content.msgType ? 'mel-' + content.msgType : 'mel-erreur',
    { 'mel-titre': content.titre },
  ]"
  class="mt-md-2"
>
  <div
    class="d-flex mb-0"
    :class="content.msgType ? 'mel-' + content.msgType + '-inner' : 'mel-erreur-inner'"
  >
    <div
      :class="
        content.msgType ? 'cercle' + capitalizeFirstLetter(content.msgType) : 'cercleErreur'
      "
    >
      <span
        :class="
          content.msgType
            ? 'cercle' + capitalizeFirstLetter(content.msgType) + '-contenu'
            : 'cercleErreur-contenu'
        "
        v-html="cercleErreurContenu"
      />
    </div>
    <div class="ml-1">
      <p v-if="content.titre" class="font-weight-bold pt-0 mb-4px" v-html="content.titre" />
      <span
        :id="content.idHTMLContenu"
        :class="content.msgType ? 'message-' + content.msgType : 'message-erreur'"
        v-html="content.message"
      />
    </div>
  </div>
</div>
